import React from 'react';
import { createComponent } from '@lit-labs/react';

import Dsy from './dsyui';

const LitComp = Dsy.components.DsyWizardSteps;

export const DsyWizardSteps = createComponent(
  React,
  'dsy-wizard-steps',
  LitComp,
  {},
);

export default DsyWizardSteps;
